// Module
var code = "<div class=\"label-container\"> <span class=\"label\">{{key}}</span> <span>: </span> <span class=\"label-value\" title=\"{{value}}\">{{value}}</span> </div> ";
// Exports
export default code;